import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class DrivenWheelsSpecificationVehiclesValueObject extends ValueObject {
  #drivenWheels

  constructor({drivenWheels}) {
    super()
    this.#drivenWheels = drivenWheels
  }

  static empty() {
    return new DrivenWheelsSpecificationVehiclesValueObject({drivenWheels: SpecificationVehiclesValueObject.empty()})
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return DrivenWheelsSpecificationVehiclesValueObject.empty()

    const {DRIVEN_WHEELS} = ConfigContext.get('vehicleSpecifications')

    const {icon, name} = DRIVEN_WHEELS[id]

    return new DrivenWheelsSpecificationVehiclesValueObject({
      drivenWheels: SpecificationVehiclesValueObject.createFromLiterals({icon, id, name})
    })
  }

  get icon() {
    return this.#drivenWheels.icon
  }

  get id() {
    return this.#drivenWheels.id
  }

  get name() {
    return this.#drivenWheels.name
  }

  get value() {
    return this.#drivenWheels.value
  }

  isEmpty() {
    return this.#drivenWheels.isEmpty()
  }
}
